import PropTypes from 'prop-types'
import { Alert, Box, MenuItem, Typography } from '@mui/material'

import useTranslations from '../../../../i18n/useTranslations'
import Select from '../../../../ui/components/select'

import styles from './styles'

const PickUpDateMobileView = ({ timetableOptions, defaultValue, children }) => {
  const t = useTranslations()

  return (
    <Box sx={styles.pickupDateContainer}>
      <Select
        defaultValue={defaultValue}
        id="pickUpTimetable"
        name="pickUpTimetable"
        labelId="pick-up-timetable"
        sx={styles.select}
      >
        {timetableOptions.map(({ value, label, icon, action }) => (
          <MenuItem key={value} value={value} onClick={action}>
            {icon}
            {label}
          </MenuItem>
        ))}
      </Select>

      {children}

      <Alert severity="warning" sx={styles.alert}>
        <Typography variant="body2">
          {t('shipping-send-message:schedule-may-change')}
        </Typography>
      </Alert>
    </Box>
  )
}

PickUpDateMobileView.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  timetableOptions: PropTypes.array.isRequired,
  children: PropTypes.node,
}

export default PickUpDateMobileView
